import { render } from "./Servidores.vue?vue&type=template&id=2c7798e3&scoped=true"
import script from "./Servidores.vue?vue&type=script&lang=js"
export * from "./Servidores.vue?vue&type=script&lang=js"

import "./Servidores.vue?vue&type=style&index=0&id=2c7798e3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7798e3"]])

export default __exports__